/*
企业互联相关
 */
import request from "@/utils/http"
import { getCachedObj } from "@/utils/cache"
import store from "@/store"

/*
企业互联类型
 */
export function saveCompanyConnectType({ id, name, description, rules }) {
  return request
    .post("/connect/saveCompanyConnectType", { id, name, description, rules })
    .commonDeal()
}

export function deleteCompanyConnectType(typeId) {
  return request
    .post("/connect/deleteCompanyConnectType", null, { params: { typeId } })
    .commonDeal()
}

export function getCompanyConnectType({ withNum = true, noCache = true } = {}) {
  let reqFunc = () => request.post("/connect/getCompanyConnectType", { withNum }).commonDeal()
  if (noCache) {
    return reqFunc()
  }
  let key = `getCompanyConnectType_${store.getters.userInfo.companyId}`
  return getCachedObj({ key, reqFunc })
}

/*
企业互联管理
 */
export function createCompanyConnect({ targetId, description, status, typeIds }) {
  return request
    .post("/connect/createCompanyConnect", { targetId, description, status, typeIds })
    .commonDeal()
}

export function sendCompanyConnectCode(connectId) {
  return request
    .post("/connect/sendCompanyConnectCode", null, { params: { id: connectId } })
    .commonDeal()
}

export function completeCompanyConnect(connectId, code) {
  return request
    .post("/connect/completeCompanyConnect", null, { params: { id: connectId, code } })
    .commonDeal()
}

export function updateCompanyConnect({ id, description, typeIds }) {
  return request.post("/connect/updateCompanyConnect", { id, description, typeIds }).commonDeal()
}

export function deleteCompanyConnect(connectId) {
  return request
    .post("/connect/deleteCompanyConnect", null, { params: { id: connectId } })
    .commonDeal()
}

/**
 * 解除/恢复企业互联
 * @param connectId
 * @param lock
 * @returns {Promise<unknown>}
 */
export function lockCompanyConnect(connectId, lock) {
  return request
    .post("/connect/lockCompanyConnect", null, { params: { id: connectId, lock } })
    .commonDeal()
}

export function getCompanyConnectList({ noCache = true, activeOnly = false, passive = true } = {}) {
  let reqFunc = () =>
    request
      .get("/connect/getCompanyConnectList", { params: { passive: passive } })
      .commonDeal()
      .then(companies => {
        return activeOnly ? companies.filter(t => t.status === "互联中") : companies
      })
  if (noCache) {
    return reqFunc()
  }
  let key = `getCompanyConnectList_${store.getters.userInfo.companyId}`
  return getCachedObj({ key, reqFunc })
}

/**
 * 获取已建立互联的企业列表
 * 包括主动发起也被动连接的所有互联企业
 * @returns {Promise<*>}
 */
export function getAllConnectedCompany({ noCache = false } = {}) {
  if (store.getters.isTemplateMode) {
    return Promise.resolve([])
  }
  let reqFunc = () => request.get("/connect/getAllConnectedCompany").commonDeal()
  if (noCache) {
    return reqFunc()
  }
  let key = `getAllConnectedCompany_${store.getters.userInfo.companyId}`
  return getCachedObj({ key, reqFunc })
}

export function searchCompanyList(searchText) {
  return request.get("/connect/searchCompanyList", { params: { searchText } }).commonDeal()
}

/*
数据同步规则(主)
 */

/**
 * 创建数据同步规则配置内容
 * @param name
 * @param description
 * @param sheetId
 * @param isExport
 * @param targetCId
 * @param rows
 * @param filters
 * @param enable
 * @param operateTypeMap
 * @param appId
 * @returns {Promise<*>}
 */
export function createSyncRuleMaster(
  {
    name = "",
    description = "",
    sheetId = "",
    isExport = true,
    targetCId = "",
    rows = [],
    filters = [],
    enable = true,
    operateTypeMap = {}
  },
  appId
) {
  return request
    .post(
      "/connect/createSyncRuleMaster",
      {
        name,
        description,
        sheetId,
        export: isExport,
        targetCId,
        rows,
        filters,
        enable,
        operateTypeMap
      },
      { params: { appId } }
    )
    .commonDeal()
}

/**
 * 编辑数据同步规则配置内容
 * @param id
 * @param name
 * @param description
 * @param sheetId
 * @param isExport
 * @param targetCId
 * @param rows
 * @param filters
 * @param enable
 * @param operateTypeMap
 * @returns {Promise<*>}
 */
export function updateSyncRuleMaster({
  id = "",
  name = "",
  description = "",
  sheetId = "",
  isExport = true,
  targetCId = "",
  rows = [],
  filters = [],
  enable = true,
  operateTypeMap = {}
}) {
  return request
    .post("/connect/updateSyncRuleMaster", {
      id,
      name,
      description,
      sheetId,
      export: isExport,
      targetCId,
      rows,
      filters,
      enable,
      operateTypeMap
    })
    .commonDeal()
}

/**
 * 启用/禁用数据同步规则配置内容
 * @param id
 * @param enable
 * @returns {Promise<*>}
 */
export function enableSyncRuleMaster(id, enable) {
  return request
    .post("/connect/enableSyncRuleMaster", null, { params: { id, enable } })
    .commonDeal()
}

/**
 * 删除数据同步规则配置内容
 * @param id
 * @returns {Promise<*>}
 */
export function deleteSyncRuleMaster(id) {
  return request.post("/connect/deleteSyncRuleMaster", null, { params: { id } }).commonDeal()
}

/**
 * 获取当前企业所有数据同步规则配置方
 * @returns {Promise<*>}
 */
export function getAllSyncRuleMasterList() {
  return request.get("/connect/getAllSyncRuleMasterList").commonDeal()
}

/**
 * 获取当前应用所有数据同步规则配置方
 * @returns {Promise<*>}
 */
export function getSyncRuleMasterList(appId) {
  return request.get("/connect/getSyncRuleMasterList", { params: { appId } }).commonDeal()
}

/**
 * 获取当前应用所有输出规则
 */
export function getOutSyncRuleList(appId) {
  return request.get("/connect/getExportSyncRuleList", { params: { appId } }).commonDeal()
}

/*
数据同步规则(从)
 */

/**
 * 获取当前企业可对接的同步规则列表
 * @returns {Promise<*>}
 */

/**
 * 获取数据同步规则对接内容列表
 * @param appId
 * @returns {Promise<*>}
 */
export function getSyncRuleSlaveList(appId) {
  return request.get("/connect/getSyncRuleSlaveList", { params: { appId } }).commonDeal()
}

/**
 * 批量初始化数据同步规则对接内容
 * @param masterIds
 * @param appId
 * @returns {Promise<*>}
 */
export function createSyncRuleSlaves(masterIds, appId) {
  return request
    .post("/connect/createSyncRuleSlaves", masterIds, { params: { appId } })
    .commonDeal()
}

/**
 * 获取当前企业可对接的同步规则列表
 * @returns {Promise<*>}
 */
export function getAvailableRuleList() {
  return request.get("/connect/getAvailableRuleList").commonDeal()
}

/**
 * 启用/禁用数据同步规则对接内容
 * @param id
 * @param enable
 * @returns {Promise<*>}
 */
export function enableSyncRuleSlave(id, enable) {
  return request.post("/connect/enableSyncRuleSlave", null, { params: { id, enable } }).commonDeal()
}

/**
 * 删除数据同步规则对接内容
 * @param id
 * @returns {Promise<*>}
 */
export function deleteSyncRuleSlave(id) {
  return request.post("/connect/deleteSyncRuleSlave", null, { params: { id } }).commonDeal()
}

/**
 * 编辑数据同步规则对接内容
 * @param id
 * @param sheetId
 * @param connectInfo
 * @param filters
 * @returns {Promise<*>}
 */
export function updateSyncRuleSlave({ id = "", sheetId = "", connectInfo = [], filters = [] }) {
  return request
    .post("/connect/updateSyncRuleSlave", {
      id,
      sheetId,
      connectInfo,
      filters
    })
    .commonDeal()
}
